module.exports = __webpack_public_path__ + "img/img_platform02.156482c8.jpg";